"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var typescript_ioc_1 = require("@logio/typescript-ioc");

var utils_1 = require("../../core/utils");

var ForecastSimulationTreeDataDTO_1 = require("../model/ForecastSimulationTreeDataDTO");

var ForecastSimulationTreeDataDTOConverter_1 = require("./ForecastSimulationTreeDataDTOConverter");

var SimulatedColumnConverter_1 = require("./SimulatedColumnConverter");

var SimulatedKpiValueDTOConverter_1 = require("./SimulatedKpiValueDTOConverter");
/**
 * @author PKr
 * @author Tomáš Leity
 */


var ForecastSimulationTreeDataDTOConverterImpl =
/*#__PURE__*/
function (_ForecastSimulationTr) {
  _inherits(ForecastSimulationTreeDataDTOConverterImpl, _ForecastSimulationTr);

  function ForecastSimulationTreeDataDTOConverterImpl(simulatedColumnBigNumConverter, simulatedColumnStringConverter, simulatedKpiValueDTOConverter) {
    var _this;

    _classCallCheck(this, ForecastSimulationTreeDataDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationTreeDataDTOConverterImpl).call(this));
    _this.simulatedColumnBigNumConverter = simulatedColumnBigNumConverter;
    _this.simulatedColumnStringConverter = simulatedColumnStringConverter;
    _this.simulatedKpiValueDTOConverter = simulatedKpiValueDTOConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ForecastSimulationTreeDataDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO(ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.entityName.valueOf(source.entityName), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.originId.valueOf(!utils_1.Utils.isValueMissing(source.originId) ? conversions.toClassReferenceId(source.originId) : null), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.dummy.valueOf(source.dummy), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.windowId.valueOf(!utils_1.Utils.isValueMissing(source.windowId) ? conversions.toClassReferenceId(source.windowId) : null), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.productExtId.valueOf(source.productExtId), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.name.valueOf(source.name), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.sku.valueOf(source.sku), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.windowWFState.valueOf(source.windowWFState), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.store.valueOf(source.store), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.startWeekDate.valueOf(!utils_1.Utils.isValueMissing(source.startWeekDate) ? conversions.toDate(source.startWeekDate) : null), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.endWeekDate.valueOf(!utils_1.Utils.isValueMissing(source.endWeekDate) ? conversions.toDate(source.endWeekDate) : null), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.daysValid.valueOf(source.daysValid), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.promoPriceLevel.valueOf(source.promoPriceLevel), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.promoDiscount.valueOf(!utils_1.Utils.isValueMissing(source.promoDiscount) ? conversions.toBigNumber(source.promoDiscount) : null), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.secondaryPlacement.valueOf(source.secondaryPlacement), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.leafletFee.valueOf(source.leafletFee), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.supplierCurrency.valueOf(source.supplierCurrency), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.posType.valueOf(source.posType), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.filterFlags.valueOf(source.filterFlags ? conversions.asObjectList(source, 'filterFlags', function (x) {
        return x;
      }) : undefined), //
      ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.windowTypeId.valueOf(conversions.asObjectOpt(source, 'windowTypeId', function (obj) {
        return _this2.simulatedColumnStringConverter.toObject(obj, conversions);
      })), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.windowName.valueOf(conversions.asObjectOpt(source, 'windowName', function (obj) {
        return _this2.simulatedColumnStringConverter.toObject(obj, conversions);
      })), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.regularPrice.valueOf(conversions.asObjectOpt(source, 'regularPrice', function (obj) {
        return _this2.simulatedColumnBigNumConverter.toObject(obj, conversions);
      })), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.promoPrice.valueOf(conversions.asObjectOpt(source, 'promoPrice', function (obj) {
        return _this2.simulatedColumnBigNumConverter.toObject(obj, conversions);
      })), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.promoVolume.valueOf(conversions.asObjectOpt(source, 'promoVolume', function (obj) {
        return _this2.simulatedColumnBigNumConverter.toObject(obj, conversions);
      })), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.posMechanics.valueOf(conversions.asObjectOpt(source, 'posMechanics', function (obj) {
        return _this2.simulatedColumnStringConverter.toObject(obj, conversions);
      })), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.posMarginImpactTheoretical.valueOf(conversions.asObjectOpt(source, 'posMarginImpactTheoretical', function (obj) {
        return _this2.simulatedColumnBigNumConverter.toObject(obj, conversions);
      })), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.purchasePrice.valueOf(conversions.asObjectOpt(source, 'purchasePrice', function (obj) {
        return _this2.simulatedColumnBigNumConverter.toObject(obj, conversions);
      })), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.unitBackDiscount.valueOf(conversions.asObjectOpt(source, 'unitBackDiscount', function (obj) {
        return _this2.simulatedColumnBigNumConverter.toObject(obj, conversions);
      })), ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.vaValue.valueOf(conversions.asObjectOpt(source, 'vaValue', function (obj) {
        return _this2.simulatedColumnBigNumConverter.toObject(obj, conversions);
      })), //
      ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.schema.kpiValues.valueOf(conversions.asObjectOpt(source, 'kpiValues', function (obj) {
        return _this2.kpiValuesToObject(obj, conversions);
      })));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        entityName: source.entityName,
        originId: !utils_1.Utils.isValueMissing(source.originId) ? conversions.toDocumentReferenceId(source.originId) : null,
        dummy: source.dummy,
        windowId: !utils_1.Utils.isValueMissing(source.windowId) ? conversions.toDocumentReferenceId(source.windowId) : null,
        productExtId: source.productExtId,
        name: source.name,
        sku: source.sku,
        windowWFState: source.windowWFState,
        store: source.store,
        startWeekDate: !utils_1.Utils.isValueMissing(source.startWeekDate) ? conversions.fromDate(source.startWeekDate) : null,
        endWeekDate: !utils_1.Utils.isValueMissing(source.endWeekDate) ? conversions.fromDate(source.endWeekDate) : null,
        daysValid: source.daysValid,
        promoPriceLevel: source.promoPriceLevel,
        promoDiscount: !utils_1.Utils.isValueMissing(source.promoDiscount) ? conversions.fromBigNumber(source.promoDiscount) : null,
        secondaryPlacement: source.secondaryPlacement,
        leafletFee: source.leafletFee,
        supplierCurrency: source.supplierCurrency,
        posType: source.posType,
        filterFlags: source.filterFlags ? conversions.asObjectArray(source, 'filterFlags', function (x) {
          return x;
        }) : null
      });
      Object.assign(result, {
        windowTypeId: !utils_1.Utils.isValueMissing(source.windowTypeId) ? this.simulatedColumnStringConverter.toDocument(source.windowTypeId, conversions) : null,
        windowName: !utils_1.Utils.isValueMissing(source.windowName) ? this.simulatedColumnStringConverter.toDocument(source.windowName, conversions) : null,
        regularPrice: !utils_1.Utils.isValueMissing(source.regularPrice) ? this.simulatedColumnBigNumConverter.toDocument(source.regularPrice, conversions) : null,
        promoPrice: !utils_1.Utils.isValueMissing(source.promoPrice) ? this.simulatedColumnBigNumConverter.toDocument(source.promoPrice, conversions) : null,
        promoVolume: !utils_1.Utils.isValueMissing(source.promoVolume) ? this.simulatedColumnBigNumConverter.toDocument(source.promoVolume, conversions) : null,
        posMechanics: !utils_1.Utils.isValueMissing(source.posMechanics) ? this.simulatedColumnStringConverter.toDocument(source.posMechanics, conversions) : null,
        posMarginImpactTheoretical: !utils_1.Utils.isValueMissing(source.posMarginImpactTheoretical) ? this.simulatedColumnBigNumConverter.toDocument(source.posMarginImpactTheoretical, conversions) : null,
        purchasePrice: !utils_1.Utils.isValueMissing(source.purchasePrice) ? this.simulatedColumnBigNumConverter.toDocument(source.purchasePrice, conversions) : null,
        unitBackDiscount: !utils_1.Utils.isValueMissing(source.unitBackDiscount) ? this.simulatedColumnBigNumConverter.toDocument(source.unitBackDiscount, conversions) : null,
        vaValue: !utils_1.Utils.isValueMissing(source.vaValue) ? this.simulatedColumnBigNumConverter.toDocument(source.vaValue, conversions) : null
      });
      Object.assign(result, {
        kpiValues: !utils_1.Utils.isValueMissing(source.kpiValues) ? this.kpiValuesToDocument(source.kpiValues, conversions) : null
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "objectToArray",
    value: function objectToArray(instance, conversions) {
      var document = this.toDocument(instance, conversions);
      var arr = ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.dataOrder.map(function (key) {
        return document[key];
      });
      return immutable_1.List(arr);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "arrayToObject",
    value: function arrayToObject(source, conversions) {
      var data = {};
      ForecastSimulationTreeDataDTO_1.ForecastSimulationTreeDataDTO.dataOrder.forEach(function (value, index) {
        if (source[index] !== undefined) {
          data[value] = source[index];
        }
      });
      return this.toObject(data, conversions);
    }
    /**
     * Converts document of KpiValues to data object
     * @param obj
     * @param conversions
     */

  }, {
    key: "kpiValuesToObject",
    value: function kpiValuesToObject(obj, conversions) {
      var _this3 = this;

      var result = {};
      Object.keys(obj).forEach(function (key) {
        result[key] = _this3.simulatedKpiValueDTOConverter.toObject(obj[key], conversions);
      });
      return result;
    }
    /**
     * Converts model object of KpiValues to document
     * @param kpiValueDTOs
     * @param conversions
     */

  }, {
    key: "kpiValuesToDocument",
    value: function kpiValuesToDocument(kpiValueDTOs, conversions) {
      var result = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = kpiValueDTOs.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              kpiValueDTO = _step$value[1];

          result[key] = this.simulatedKpiValueDTOConverter.toDocument(kpiValueDTO, conversions);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result;
    }
  }]);

  return ForecastSimulationTreeDataDTOConverterImpl;
}(ForecastSimulationTreeDataDTOConverter_1.ForecastSimulationTreeDataDTOConverter);

ForecastSimulationTreeDataDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __metadata("design:paramtypes", [SimulatedColumnConverter_1.SimulatedColumnBigNumConverter, SimulatedColumnConverter_1.SimulatedColumnStringConverter, SimulatedKpiValueDTOConverter_1.SimulatedKpiValueDTOConverter])], ForecastSimulationTreeDataDTOConverterImpl);
exports.ForecastSimulationTreeDataDTOConverterImpl = ForecastSimulationTreeDataDTOConverterImpl;